import { createTheme, alpha } from "@material-ui/core/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      light: "#ED8B00",
      main: "#FF6400",
      dark: "#E65A00",
    },
    secondary: {
      light: "#C9E4B4",
      main: "#73B241",
      dark: "#548330",
    },
    error: {
      light: "#ED7895",
      main: "#CD1C48",
      dark: "#A21638",
    },
    success: {
      light: "#C9E4B4",
      main: "#00A3E0",
      dark: "#0072CE",
    },
    background: {
      default: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: "Open Sans, sans-serif",
  },
  overrides: {
    MuiButton: {
      root: {
        "&.MuiButton-outlined.Mui-disabled": {
          border: "2px solid #D9D9D9",
          color: "#D9D9D9",
        },
      },
      contained: {
        boxShadow: "none",
        borderRadius: "24px",
        padding: "14px 32px",
        fontSize: "14px",
        letterSpacing: "0.5px",
        lineHeight: "14px",
        fontWeight: 700,
        height: "48px",
        "&:hover": {
          boxShadow: "none",
        },
      },
      outlined: {
        height: "48px",
        padding: "14px 32px",
        borderRadius: "24px",
        minWidth: "114px",
        display: "inline-flex",
      },
      label: {
        fontSize: "14px",
        fontWeight: 700,
      },
      outlinedPrimary: {
        borderWidth: "2px",
        color: "#FF6400",
        border: "2px solid #FF6400",
        "&:hover": {
          borderWidth: "2px",
          backgroundColor: "transparent",
          color: "#CC5000",
          border: "2px solid #CC5000",
        },
      },
      containedPrimary: {
        color: "#FFFFFF",
      },
      outlinedSecondary: {
        borderWidth: "2px",
        color: "#73B241",
        border: "2px solid #73B241",
        "&:hover": {
          borderWidth: "2px",
          backgroundColor: "transparent",
          color: "#548330",
          border: "2px solid #548330",
        },
      },
      containedSecondary: {
        color: "#FFFFFF",
      },
    },
    MuiInputLabel: {
      root: {
        color: "#1E1F21",
      },
    },
    MuiInput: {
      root: {
        color: "#1E1F21",
        "& .MuiInputBase-input": {
          "&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus,&:-webkit-autofill:active":
            {
              boxShadow: "0 0 0 30px white inset !important",
            },
        },
      },
    },
    MuiAlert: {
      filledSuccess: {
        backgroundColor: "#73B241",
      },
      filledError: {
        backgroundColor: "#CD1C48",
      },
      filledWarning: {
        backgroundColor: "#FF6400",
      },
      message: {
        fontWeight: 600,
        fontSize: "14px",
        color: "#FFFFFF",
      },
    },
  },
  custom: {
    color: {
      apple: "#73B241",
      lapalma: "#548330",
      black: "#000000",
      white: "#FFFFFF",
      pewter: "#969696",
      gainsboro: "#D9D9D9",
      blackRussian: "#1E1F21",
      mortar: "#585858",
      silver: "#B8B8B8",
      summersky: "#1CB7DA",
      crimson: "#CD1C48",
      gold: "#EDC900",
    },
    border: {
      primary: "1px solid rgba(224, 224, 224, 0.5)",
      secondary: "1px solid #D9D9D9",
      tab: "4px solid #D9D9D9",
      listItem: "1px solid " + alpha("#D9D9D9", 0.5),
      active: "2px solid #00A3E0",
    },
    boxShadow: {
      primary: "0 2px 40px -4px rgba(0,0,0,0.15)",
      tooltip: "0 4px 5px 0 rgba(0,0,0,0.1)",
      paper: "0 7px 9px -4px rgba(0,0,0,0.05), 0 5px 26px 4px rgba(0,0,0,0.08)",
    },
    linkHover: {
      color: "#CC5000",
    },
  },
});

export default theme;
